import { REVIEW_EMAIL } from "@/constants/components/review-email";
import { CustomToastrAction, toastr, TRANSLATION, Yup } from "@/imports-files/common/common";
import { addParamsToUrl } from "@/imports-files/pages/clients/candidates/kanban";
import { ReviewEmailServices } from "@/services/components/review-email";
import { EmailTemplatesService } from "@/services/pages/clients/recruitment/email-templates";

export class ReviewEmailActions
{

    constructor()
    {
        this.reviewEmailService     =   new ReviewEmailServices();
        this.customToastrAction     =   new CustomToastrAction();
    }

    async submitReviewEmail(values, setReviewEmail, emailTemplateInfo, emailTemplateData, setEmailTemplateData, setFlagForRender, formRef, router, setDisabledSubmitButton)
    {

        let result = '';
        let body   = {};
        setDisabledSubmitButton(true);

        if(emailTemplateInfo.operation_type == 'create')
        {
            body                              =  {values};
            body.values['type']               =  router.query.email_type
            body.values['master_template_id'] =  values.master_template_id;
            result                            =  await this.reviewEmailService.createCustomEmail(values);

            if(result.request.status==200)
            {
                this.customToastrAction.setNormalToastr(result.success, 'success');
                // toastr.success(result.success);
                setEmailTemplateData({count: result.data.total_count ,data: result.data.templates});
                setReviewEmail(false);
            }
            else
            {
                formRef.current.setStatus(result.response.data.error);
            }
            await delete router.query.purpose;
            await delete router.query.created_at;
            await delete router.query.created_by;

            addParamsToUrl(router.query, router);
            setFlagForRender(Math.random() * 10000);
        }
        else if(emailTemplateInfo.operation_type == 'edit')
        {
            body        =   {email_body: values.template.email_body, subject: values.template.subject, type: router.query.email_type, default: values.template?.default, purpose: values.template.purpose};
            if(router.query.created_by) body.created_by = router.query.created_by
            result      =   await this.reviewEmailService.updateEmailTemplate(body, values.template.master_template_id);

            if(result.request.status == 200)
            {
                var newTemplateData = emailTemplateData.map(emailTemplate => {
                    if(emailTemplate.id == emailTemplateInfo.template_id){
                        return result.data
                    }
                    else{
                       return emailTemplate
                    }
                })

                this.customToastrAction.setNormalToastr(result.data.success, 'success');
                // toastr.success(result.data.success);
                setEmailTemplateData({count: emailTemplateData.length ,data: newTemplateData});
                setReviewEmail(false);

            }
            else
            {
                formRef.current.setStatus(result.response.data.error);
            }
        }
        setDisabledSubmitButton(false);
    }


    async getEmailTemplateData(router, info, template_id, emailTemplateData, type)
    {

        let template_data  = '';
        let body = '';

        if(type=='kanban')
        {
            let purposelist = []
            return {template_data: {data: emailTemplateData.templates[0]}, purpose_list: purposelist }
        }
        else if(router.query.email_type=='custom')
        {
            body = {type: 'custom', master: false};
            if(router.query.created_by) body.created_by = router.query.created_by
            template_data = await this.reviewEmailService.getCustomEmailTemplate(body,template_id);
        }
        else if(router.query.email_type=='system')
        {
            body = {type: 'system', master: false};
            template_data = await this.reviewEmailService.getSystemEmailTemplate(body,template_id);
        }

        if(info.operation_type == 'create')
        {
            var purpose_list = await this.getSystemPurposeList({});
            return {template_data: template_data, purpose_list: purpose_list};
        }
        else
        {
            return {template_data: template_data, purpose_list: []};
        }



    }

    setFormInitialValues(initalData, type)
    {
            if(type == 'kanban')
                {
                    REVIEW_EMAIL.email_template.formInitialValue.template.master_template_id  =  initalData.master_template_id  || ''
                    REVIEW_EMAIL.email_template.formInitialValue.template.master_template_type  =  initalData.master_template_type  || ''
                }
            else
                REVIEW_EMAIL.email_template.formInitialValue.template.master_template_id  =  initalData.id || ''
            REVIEW_EMAIL.email_template.formInitialValue.template.master_template_type  =  initalData.master_template_type  || ''
            REVIEW_EMAIL.email_template.formInitialValue.template.subject             =  initalData.subject    || ''
            REVIEW_EMAIL.email_template.formInitialValue.template.email_body          =  initalData.email_body || ''
            REVIEW_EMAIL.email_template.formInitialValue.template.default             =  initalData.default    || false
            REVIEW_EMAIL.email_template.formInitialValue.template.purpose             =  initalData.purpose || ''

            return REVIEW_EMAIL.email_template.formInitialValue;
    }

    getFormFieldsName()
    {
        return { type: 'template', master_template_id:'master_template_id', subject:'subject', body:'email_body', default: 'default', master_template_type:'master_template_type', master_template_attributes: 'master_template_attributes', purpose: 'purpose'}
    }

    async resetTemplate(template_id, setReviewEmail)
    {
        var body = {type: 'system'};
        var result = await this.reviewEmailService.resetEmailTemplate(body, template_id);
        if(result.request.status == 200)
        {
            setReviewEmail(false);
            this.customToastrAction.setNormalToastr(result.data.success, 'success');
            // toastr.success(result.data.success);
        }
    }

    getPurposeOptions(emailTemplateData, type, t)
    {
        let options = [{value: 'add_custom', 'label': t('label:add:new_purpose'), type: 'CustomTemplate', template_type: 'custom', template_id: ''}];
        let data    =  Array.isArray(emailTemplateData) ? emailTemplateData : [emailTemplateData];
        if(data)
        {
            for( let element of data)
            {
                options.push({
                                value: type == 'kanban' ? element.master_template_id : element.id,
                                label: element.purpose,
                                type: element.type,
                                template_type: element.template_type,
                                template_id: element.template_id
                             })
            }
            return {options: options};
        }
        else
        {
            return [];
        }
    }

    async getSystemEmailTemplate(select_option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, t)
    {
      var master_template_id  =    select_option.value
      var master_template_type  =    select_option.type
      var template_type  =    select_option.template_type
      var template_id  =    select_option.template_id
      if(master_template_id == 'add_custom'){
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.subject}`, '');
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.body}`, '');
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_id}`, master_template_id);
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_type}`, master_template_type);

        setSubject(this.subjectVars(t));
        setDataVariables(this.bodyVars(t));
        setRefreshKey(Math.random() * 10000);
      }
      else{
          var body         =    {type: template_type, master: template_type == 'system' ? true : false};
          var result       =    await this.reviewEmailService.getSystemEmailTemplate(body, template_id);

          if(result.request.status == 200)
          {
            await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.subject}`, result.data.subject);
            await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.body}`, result.data.email_body);
            await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_id}`, master_template_id);
            await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_type}`, master_template_type);

            setSubject(result.data.subject_variables);
            setDataVariables(result.data.data_variables);
            setRefreshKey(Math.random() * 10000);
          }
      }
    }

    async getSystemPurposeList(params)
    {
        let system_result =    await new EmailTemplatesService().getSystemPurposeList();
        if(system_result.request.status == 200)
        {
            if(params.only_custom){
                system_result.data.purposes_list.map((x) => {
                    if(x.template_type == 'system'){
                        x.is_custom_master = true     
                    }
                    else {
                        x.is_custom_master = false
                    }
                    return x;
                })
            }
            return system_result.data.purposes_list;
        }
        else
        {
            return [];
        }
    }

    async saveEmailTemplate(values, job_id, router, setHideModalClass, setReviewEmail, formRef, setDisabledSubmitButton)
    {
      setDisabledSubmitButton(true);
      const params = values
      let system_result =    await new EmailTemplatesService().saveEmailTemplate(params, job_id);
      if(system_result.request.status == 200)
      {
            setReviewEmail(false)
            setHideModalClass(false)
          return system_result.data;
      }
      else{
         formRef.current.setStatus(system_result.response.data.error);
      }
      setDisabledSubmitButton(false);
    }

    bodyVars(t){
        let values = [t('modal:data_variables:company_name'),
                      t('modal:data_variables:candidate_first_name'),
                      t('modal:data_variables:job_title'),
                      t('modal:data_variables:client_user_name'),
                      t('modal:data_variables:client_user_email_signature'),
                      t('modal:data_variables:user_email'),
                      t('modal:data_variables:website_url'),
                      t('modal:data_variables:job_url'),
                      t('modal:data_variables:company_facebook_url'),
                      t('modal:data_variables:company_twitter_url'),
                      t('modal:data_variables:company_linkedin_url'),
                      t('modal:data_variables:company_career_page'),
                      t('modal:data_variables:company_address')]
        let body = []
        values.map((val) => {
            body.push({text: val, value: `{{${val}}}`})
        })
        return body;
    }

    subjectVars(t){
        let values = [t('modal:data_variables:company_name'),
                      t('modal:data_variables:candidate_first_name'),
                      t('modal:data_variables:job_title'),
                      t('modal:data_variables:client_user_name'),
                      t('modal:data_variables:user_email'),
                      t('modal:data_variables:company_address')]
        let subject = []
        values.map((val) => {
            subject.push({text: val, value: `{{${val}}}`})
        })
        return subject;
    }

    kanbanPurposeList(emailTemplateData){
      let options = []
      emailTemplateData.templates.forEach((value, index) => {
        options.push({value: index, label: value.purpose})
      })
      return options
    }

    async setSystemTemplate(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, emailTemplateData){
        let data = emailTemplateData[`${option.value}`]
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.subject}`, data.subject);
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.body}`, data.email_body);
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_id}`, data.master_template_id);
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_type}`, data.master_template_type);

        setSubject(data.subject_variables);
        setDataVariables(data.data_variables);
        setRefreshKey(Math.random() * 10000);
    }

    async setUnsuccssfulModalData(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, emailTemplateData, setUnsuccessfulEmailValues){
        let data = emailTemplateData[`${option.value}`]
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_id}`, data.master_template_id);
        await formik.setFieldValue(`${formFieldNames.type}.${formFieldNames.master_template_type}`, data.master_template_type);
        if(setUnsuccessfulEmailValues)
        {
            setUnsuccessfulEmailValues({cc: '',
                                        subject: data.subject,
                                        email_body: data.email_body,
                                        entity_type: data.entity_type
                                      })
        }
            setSubject(data.subject_variables);
            setDataVariables(data.data_variables);
            setRefreshKey(Math.random() * 10000);
    }

    formValidation(current_purpose_type){
        return  Yup.object().shape({
          template: Yup.object({
            master_template_id     :   Yup.string().required(TRANSLATION('errors:required')),
            purpose: Yup.string().when([], {
                is: () => {
                  return  current_purpose_type == 'custom_template'},
                then: Yup.string().required(TRANSLATION('errors:required')),
                otherwise: Yup.string().notRequired().nullable(true)
            }),
            master_template_attributes: Yup.object().shape({
              purpose: Yup.string().when([], {
                is: () => {
                  return  current_purpose_type == 'add_custom'},
                then: Yup.string().required(TRANSLATION('errors:required')),
                otherwise: Yup.string().notRequired().nullable(true)
              })
            }),
            subject: Yup.string().required(TRANSLATION('errors:required')),
            email_body: Yup.string().required(TRANSLATION('errors:required'))
          })
        })
      }
}
